import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { ThemeProvider } from "@material-tailwind/react";
import {HashRouter} from "react-router-dom"
import { persistor, store } from './store';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
  <PersistGate loading={null} persistor={persistor}>
  <ThemeProvider>
  <HashRouter basename='/' >
    <App />
    </HashRouter>
  </ThemeProvider>
  </PersistGate>
  </Provider>
);



